import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal, Select } from "antd";
import { toast } from "react-toastify";
import { api } from "../../../../../config";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../../../interfaces/users";

interface ProductModalProps {
  isOpen: boolean;
  questionnaireTemplateId: number;
  questionnaireId: number | undefined;
  ticketId: number;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProductModal = ({
  isOpen,
  questionnaireTemplateId,
  questionnaireId,
  ticketId,
  setIsOpen,
}: ProductModalProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const seniorityOptions = [
    { value: 1, label: <span>Senior</span> },
    { value: 2, label: <span>Pleno</span> },
    { value: 3, label: <span>Júnior</span> },
  ];

  const [productExist, setProductExist] = useState(false);

  useEffect(() => {
    if (ticketId && questionnaireTemplateId) {
      findProduct(ticketId, questionnaireTemplateId, questionnaireId).then(
        (response) => {
          if (response) {
            setProductExist(true);
            form.setFieldsValue({
              externalId: response.externalId,
              assemblyTime: response.assemblyTime,
              seniority: response.seniorityId,
            });
          }
        }
      );
    }
  }, []);

  const findProduct = async (
    ticketId: number,
    questionnaireTemplateId: number,
    questionnaireId: number | undefined
  ) => {
    const response = await api(token).get(
      `/product?ticketId=${ticketId}&questionnaireTemplateId=${questionnaireTemplateId}&questionnaireId=${questionnaireId}`
    );
    return response[0];
  };

  const onFinish = async (values: any) => {
    if (!values.seniority || !values.assemblyTime || !values.externalId) {
      toast.error("Preencha todos os campos");
      return;
    }
    const formChanged = form.isFieldsTouched();

    if (!formChanged) {
      setIsOpen(false);
      return;
    }

    if (!questionnaireTemplateId || !ticketId) {
      return toast.error("Ocorreu um erro ao salvar o formulário");
    }

    setLoading(true);

    const payload = {
      questionnaireTemplateId: questionnaireTemplateId,
      questionnaireId: questionnaireId,
      seniorityId: values.seniority,
      type: "COMPOSED_PRODUCT",
      assemblyTime: Number(values.assemblyTime),
      externalId: values.externalId,
      ticketId: ticketId,
    };

    const existingProduct = await api(token).get(
      `product?externalId=${values.externalId}`
    );

    // try {
    let answersSent;
    if (!existingProduct.length) {
      answersSent = await api(token).post("product", payload);
    } else {
      answersSent = await api(token).put("product/" + existingProduct[0].id, {
        ...existingProduct[0],
        ...payload,
      });
    }
    toast.success("Produto salvo com sucesso!");
    setIsOpen(false);
    form.resetFields();
    return answersSent;
    // } catch (error: any) {
    //   toast.error(
    //     <div>
    //       Ocorreu um erro ao salvar o formulário.
    //       <br /> {error.response.data.error}
    //     </div>
    //   );
    //   return false;
    // } finally {
    //   setLoading(false);
    // }
  };

  const onCancel = (values: any) => {
    // if (!productExist && (!values.seniority || !values.assemblyTime || !values.code)) {
    //   toast.error("É obrigatório preencher todos os campos");
    //   return;
    // }
    setIsOpen(false);
  };

  return (
    <Modal
      title="Dados do Produto"
      open={isOpen}
      onOk={onFinish}
      footer={[]}
      onCancel={onCancel}
    >
      <Form form={form} onFinish={onFinish}>
        <p>Nível do Montador:</p>
        <Form.Item name={"seniority"}>
          <Select options={seniorityOptions} />
        </Form.Item>
        <p>Tempo de Montagem:</p>
        <Form.Item name={"assemblyTime"}>
          <Input
            type="number"
            suffix="Horas"
            min={1}
            max={32}
            defaultValue={8}
            style={{ width: 120 }}
          ></Input>
        </Form.Item>
        <p>Código do Promob:</p>
        <Form.Item name={"externalId"}>
          <InputNumber min={0}></InputNumber>
        </Form.Item>
        <div className="flex justify-end">
          <Button type="primary" htmlType="submit" loading={loading}>
            Salvar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ProductModal;
